import { Eye, Check, X } from 'lucide-react';
import { Button } from '../ui/button';

const fmt = (iso) => {
    if (!iso) return '—';
    try { return new Date(iso).toLocaleString('es-ES', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

const Item = ({ label, children }) => (
    <div className="min-w-0">
        <p className="text-[10px] uppercase tracking-wide text-slate-400">{label}</p>
        <p className="text-xs text-slate-800 font-medium break-words">{children ?? '—'}</p>
    </div>
);

const Flag = ({ ok, yes, no }) => (
    <span className={`inline-flex items-center gap-1 text-xs ${ok ? 'text-green-700' : 'text-red-600'}`}>
        {ok ? <Check className="w-3 h-3" /> : <X className="w-3 h-3" />}{ok ? yes : no}
    </span>
);

// Review panel for a diagnostic candidate whose email was already used by another invoice
export const UsedByDetail = ({ d, candidate, onViewInvoice, invoices = [] }) => {
    const loaded = invoices.find((i) => i.id === d.invoice_id);
    return (
        <div className="space-y-2" data-testid="used-by-detail">
            <p className="text-xs text-slate-600">
                Este depósito de <b>{candidate.sender_name}</b> (${Number(candidate.amount || 0).toFixed(2)}, {candidate.bank}) ya está confirmando la factura:
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
                <Item label="Factura">{d.invoice_name}</Item>
                <Item label="Usuario">{d.user_name}{d.is_extra ? ' (Extra)' : ''}</Item>
                <Item label="Monto factura">{d.amount != null ? `$${Number(d.amount).toFixed(2)}` : '—'}</Item>
                <Item label="Categoría">{d.category || '—'}</Item>
                <Item label="Confirmación">{d.how}{d.confirmed_by ? ` · ${d.confirmed_by}` : ''}</Item>
                <Item label="Confirmada el">{fmt(d.confirmed_at)}</Item>
                <Item label="Factura subida">{fmt(d.uploaded_at)}</Item>
                <Item label="Estado actual">{d.still_confirmed ? 'Confirmada' : 'Pendiente (desconfirmada)'}</Item>
                {d.description && <Item label="Descripción">{d.description}</Item>}
            </div>
            <div className="flex flex-wrap items-center gap-3">
                <Flag ok={d.same_amount} yes="Mismo monto que esta factura" no="Monto distinto a esta factura" />
                <Flag ok={d.same_name} yes="Mismo nombre que esta factura" no="Nombre distinto a esta factura" />
                {d.same_amount && d.same_name && <span className="text-xs text-amber-700 font-medium">Posible duplicado: revisa si son dos pagos reales o la misma orden subida dos veces.</span>}
                {loaded && (
                    <Button size="sm" variant="outline" className="h-6 px-2 text-xs ml-auto" onClick={() => onViewInvoice(loaded)} data-testid="used-by-view-invoice">
                        <Eye className="w-3 h-3 mr-1" /> Ver esa factura
                    </Button>
                )}
                {!loaded && d.invoice_id && <span className="text-[11px] text-slate-400 ml-auto">La factura no está en la lista actual (cambia el filtro de fechas para verla).</span>}
            </div>
        </div>
    );
};

export default UsedByDetail;
